import axios from "axios";
import { api as configs } from "../utils/config";
import { pathAPI } from "../utils/pathApi";

let refreshAccessTokenPromise: Promise<string> | null = null;

export const refreshAdminAccessToken = async (): Promise<string> => {
  if (!refreshAccessTokenPromise) {
    refreshAccessTokenPromise = axios
      .post(`${configs.baseUrl}${pathAPI.refreshToken}`, {}, { withCredentials: true })
      .then((response) => {
        const accessToken = response.data?.data?.access_token || response.data?.access_token;
        if (!accessToken) {
          throw new Error("Refresh token response missing access token");
        }

        localStorage.setItem("token", accessToken);
        return accessToken;
      })
      .finally(() => {
        refreshAccessTokenPromise = null;
      });
  }

  return refreshAccessTokenPromise;
};

const AUTH_PUBLIC_PATHS = [
  "/login",
  "/forgot-password",
  "/reset-password",
];

export const isAuthPublicRoute = (): boolean => {
  if (typeof window === "undefined") return false;
  const pathname = window.location.pathname;
  return AUTH_PUBLIC_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
};

export const clearAdminSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expires_in");
  localStorage.removeItem("email");
  localStorage.removeItem("avatar");
  localStorage.removeItem("current_user_id");
  localStorage.removeItem("current_user_role");
};

export const redirectToAdminLogin = () => {
  clearAdminSession();
  if (!isAuthPublicRoute()) {
    window.location.href = "/login";
  }
};

/**
 * Decode JWT payload to check expiration
 */
const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]));
    return payload;
  } catch {
    return null;
  }
};

/**
 * Check if JWT is expired or expiring within 60 seconds
 */
export const isTokenExpiredOrExpiring = (token: string): boolean => {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return false;

  const expiresAt = payload.exp * 1000; // Convert to milliseconds
  const now = Date.now();
  const skewMs = 60 * 1000; // 60 seconds

  return expiresAt < now + skewMs;
};
